import React from 'react';
import { TextField } from '@mui/material';

/**
 * Converte uma máscara tipo "99 99999-9999" para um valor com a entrada do usuário
 * @param {string} mask - Máscara no formato "99 99999-9999"
 * @param {string} value - Dígitos numéricos
 */
function applyMask(mask, value) {
  let masked = '';
  let i = 0;

  for (let char of mask) {
    if (char === '9') {
      masked += value[i] || '';
      i++;
    } else {
      masked += char;
    }

    if (i >= value.length) break;
  }

  return masked;
}

/**
 * Extrai apenas os números da entrada
 * @param {string} value
 */
function extractDigits(value) {
  return value.replace(/\D/g, '');
}

/**
 * Componente de TextField com máscara dinâmica usando '9' como input numérico
 */
export const MaskedField = ({ mask, value, onChange, ...props }) => {
  const handleChange = (e) => {
    const raw = extractDigits(e.target.value);
    const masked = applyMask(mask, raw);
    onChange({ target: { value: masked, rawValue: raw } }); // inclui rawValue se quiser usar
  };

  return (
    <TextField
      {...props}
      value={value}
      onChange={handleChange}
      inputProps={{ inputMode: 'numeric' }}
      fullWidth
      margin="normal"
    />
  );
};

